import { SCENE_SCALE } from "../../constants";

export const GRID_SIZE = 200 * SCENE_SCALE;

export const TEXTURE_REPEAT = 1024;